import { Map } from "mapbox-gl";
export class MapManager {
    constructor(parent) {
        this.parent = parent;
    }
    async initialize(container) {
        this.map = new Map({
            container: container,
            style: "https://api.maptiler.com/maps/ac34234e-5ce7-4a0f-95e2-0632b493fda1/style.json?key=2Piy1GKXoXq0rHzzBVDA",
            center: [4.878, 51.093],
            zoom: 4.12,
            hash: true,
        });
        // disable map rotation using right click + drag
        this.map.dragRotate.disable();
        // disable map rotation using touch rotation gesture
        this.map.touchZoomRotate.disableRotation();
        // notify when the map was created.
        this.parent.onMapCreated(this.map);
    }
    zoomIn() {
        this.map.zoomIn();
    }
    zoomOut() {
        this.map.zoomOut();
    }
}
